import { Routes } from '@angular/router';
import { AuthGuard } from '@utils/guards/auth.guard';

export const emittersRoutes: Routes = [
  {
    path: 'emisores',
    loadComponent: () =>
      import('./emitters.component').then((c) => c.EmittersComponent),
    canActivate: [AuthGuard],
  },
];
